import React, {PropTypes} from 'react';

import PetAdOptions from './PetAdOptions';

const PetAdRow = ({
	ad,
	preview,
	onClear,
	onSelected,
	onUpload,
	selected
}) => {
	return (
		<tr onClick={() => onSelected(ad)} className={selected && "table-active"}>
			<td>{ad.petType}</td>
			<td>{ad.isValid && <i className="fa fa-check fa-lg"/>}</td>
			{selected ? <PetAdOptions ad={ad} preview={preview} onClear={onClear} onUpload={onUpload}/> : <td/>}
		</tr>
	);
};

PetAdRow.propTypes = {
	ad: PropTypes.object.isRequired,
	preview: PropTypes.string.isRequired,
	onClear: PropTypes.func.isRequired,
	onSelected: PropTypes.func.isRequired,
	onUpload: PropTypes.func.isRequired,
	selected: PropTypes.bool.isRequired
};

export default PetAdRow;


/** WEBPACK FOOTER **
 ** ./src/modules/caresheets/components/PetAdRow.js
 **/